// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"5615fbfc","453":"545bd75d"}[chunkId] + ".chunk.js";
};